import { render, staticRenderFns } from "./EvaluacionMedica.vue?vue&type=template&id=7f6290e0"
import script from "./EvaluacionMedica.vue?vue&type=script&lang=js"
export * from "./EvaluacionMedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports